export default __webpack_public_path__ + "static/media/248.2c35fa36.png";